import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listClubs, getClub } from './api';
import {
  LIST_CLUBS_REQUEST,
  GET_CLUB_REQUEST,
  GET_CLUB_SUCCESS,
  CLUB_REQUESTING,
  LIST_CLUBS_SUCCESS,
  LIST_CLUBS_SUCCESS_GTM,
  RESET_CLUB_ISFETCHING
} from './constants';

export function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_REQUESTING });
    const response = yield call(listClubs);
    yield put({ type: LIST_CLUBS_SUCCESS, payload: response.data });
    if (action.isIncludeGTM) {
      yield put({ type: LIST_CLUBS_SUCCESS_GTM, payload: response.data });
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_REQUESTING });
    const response = yield call(getClub, action.slug);
    yield put({ type: GET_CLUB_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    yield put({ type: RESET_CLUB_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

export function* watchList() {
  yield takeLatest(LIST_CLUBS_REQUEST, list);
  yield takeEvery(GET_CLUB_REQUEST, get);
}

export default function* clubSagas() {
  yield all([watchList()]);
}
